<!--
  Generated template for the VirtualScrollPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->
<ion-header slot="fixed" [hidden]="inApp">

    <ion-toolbar>
        <ion-buttons slot="start">
            <custom-back-button (backButtonClick)="backButtonClick()"></custom-back-button>
        </ion-buttons>
        <ion-title *ngIf="store">{{store.name}}</ion-title>
        <ion-buttons slot="primary">
            <div class="h-nav">
                <ion-icon *ngIf="store && store.menu.settings.enableSearch && store.menu.settings.catLayout == 'none'" tappable name="ios-search"
                    class="h-nav-cart" (click)="tapSearch()">
                </ion-icon>
            </div>
        </ion-buttons>
    </ion-toolbar>

</ion-header>


<ion-content>
    <ion-virtual-scroll [items]="items" approxItemHeight="100px" approxHeaderHeight="32px" [headerFn]="getHeader" #list
                        class="animated">

        <ion-item-divider *virtualHeader="let cat" class="item-cat-box">
            <p>{{ cat.name }}</p>
        </ion-item-divider>

        <ion-item *virtualItem="let item" (click)="addClicked(item)" class="item-list-box" [ngClass]="{'selected-flag' : !isSet(item) && (store.menu.quickSingleItem || !isModifiable(item)) && orderManager.getQuantity(item) > 0}">
            <div *ngIf="isSoldout(item)" class="sold-out-box AQA-soldOut">
                <p>{{"pages.item-grid.soldout" | translate}}</p>
            </div>
            <ion-avatar slot="end">
                <ion-img *ngIf="getImage(item)" [src]="getImage(item)"></ion-img>
            </ion-avatar>
            <!-- Action bar for Set -->
            <div class="pre-quantity-box" *ngIf=" isSet(item) && orderManager.getQuantity(item) === 0" slot="end">
                <ion-button class="aig-arrow-right">
                    <ion-icon name="aig-arrow-right"></ion-icon>
                </ion-button>
            </div>
            <!-- Action bar for A-la-carte -->
            <div class="pre-quantity-box" *ngIf=" !isSet(item) && !store.menu.quickSingleItem && isModifiable(item) "
                 slot="end">
                <ion-button class="aig-arrow-right">
                    <ion-icon name="aig-arrow-right"></ion-icon>
                </ion-button>
            </div>
            <div class="pre-quantity-box" *ngIf=" !isSet(item) && (store.menu.quickSingleItem || !isModifiable(item)) && orderManager.getQuantity(item) === 0"
                 slot="end">
                <ion-button class="aig-add-circle">
                    <ion-icon name="aig-add-circle"></ion-icon>
                </ion-button>
            </div>
            <div class="quantity-box" *ngIf=" !isSet(item) && (store.menu.quickSingleItem || !isModifiable(item)) && orderManager.getQuantity(item) > 0"
                 slot="end">
                <ion-button class="aig-add-circle">
                    <ion-icon name="aig-add-circle-fill" color="button"></ion-icon>
                </ion-button>
                <div class="qty-text">{{orderManager.getQuantity(item)}}</div>
                <ion-button (click)="minusItem(item);$event.stopPropagation();" class="aig-minus-circle">
                    <ion-icon name="aig-minus-circle-fill"></ion-icon>
                </ion-button>
            </div>
            <div>
                <p class="name-text line-clamp">{{ item.name }}</p>
                <p class="desc-text AQA-itemDesc">{{ item.desc }}</p>
                <p class="price-text itemPrice-text">{{orderManager?.store?.currencySign ===  '€' ? '' : orderManager?.store?.currencySign}}
                    {{ item.price }}
                    {{orderManager?.store?.currencySign === '€' ? '€' : ''}}
                </p>
            </div>
        </ion-item>
    </ion-virtual-scroll>

    <!-- <ion-fab right bottom #fab class="theme1"> -->
    <!-- <div class="cat_menu-box" ion-fixed>
            <div *ngFor="let cat of categories" (click)="catClicked(fab, cat)" class="cat-box">
                {{cat.name}}
            </div>
    </div> -->
    <!-- <ion-fab right bottom #fab class="theme1"> -->
    <div class="virtual-bg" [ngClass]="{'dim-bg': isfabOpen}" slot="fixed">
        <ion-button *ngFor="let cat of categories" (click)="catClicked(fab, cat)" class="cat-box">
            {{cat.name}}
        </ion-button>
    </div>

    <ion-fab #fab vertical="bottom" horizontal="end" slot="fixed" (click)="triggerFab()">
        <ion-fab-button>
            <ion-icon name="{{'pages.menu-list.menu-fab' | translate}}"></ion-icon>
        </ion-fab-button>
    </ion-fab>

    <!-- <ion-fab right bottom #fab (click)="triggerFab()">
        <ion-button ion-fab>
            <ion-icon name="{{'pages.menu-list.menu-fab' | translate}}"></ion-icon>
        </ion-button>
        <ion-fab-list side="top" style="display: none;"></ion-fab-list>
    </ion-fab> -->
</ion-content>

<ion-footer>
    <!-- <ion-toolbar>
        <div class="footer-content-box" (click)="cartClicked()">
            <p [ngClass]="{'animated shake' : isBounce}" class="price-text">{{orderManager?.store?.currencySign}} {{getCurrentTotalPrice() | number : '1.'+ orderManager?.getPrecision()||0 + '-' + orderManager?.getPrecision()||2}}</p>
            <span tappable class="action-btn-box">
                <ion-icon name="cart" class="h-nav-cart"></ion-icon>
                <p>{{"pages.virtual-scroll-category-list.cart" | translate}}</p>
                <ion-icon name="aig-arrow-right" class=" animated" [ngClass]="{shaking: multOrderManager.getOrderCount() > 0}"></ion-icon>
            </span>
        </div>
    </ion-toolbar> -->

        <ion-button expand="block" (click)="cartClicked()" class="key-btn-box order-btn full-btn-shadow AQA-key-button">
                <ion-chip [ngClass]="{'animated popped' : isBounce}" class="item-count-chip">
                    <ion-label>{{orderManager?.store?.currencySign ===  '€' ? '' : orderManager?.store?.currencySign}}
                        {{getCurrentTotalPrice()| number : '1.'+ orderManager?.getPrecision()||0 + '-' + orderManager?.getPrecision()||2}}
                        {{orderManager?.store?.currencySign === '€' ? '€' : ''}}
                    </ion-label>
                </ion-chip>
                <p class="checkout-text">
                    {{"global.checkout" | translate}}
                </p>
                <ion-icon slot="end" name="ios-arrow-forward" class=" animated" [ngClass]="{shaking: multOrderManager.getOrderCount() > 0}"></ion-icon>
        </ion-button>



</ion-footer>
